export const designSearch = {
    noData: '暂无相关设计',
    input: '输入方案名称',
    placeHolder: '输入关键词搜索',
    contactOfficial: '联系官方上传',
};
